/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_ApprovalsInputs */

const en_tut_sc_approvals = /** @type {(inputs: Tut_Sc_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Approvals`)
};

const id_tut_sc_approvals = /** @type {(inputs: Tut_Sc_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Approval`)
};

/**
* | output |
* | --- |
* | "Jump to Approvals" |
*
* @param {Tut_Sc_ApprovalsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_approvals = /** @type {((inputs?: Tut_Sc_ApprovalsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_ApprovalsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_approvals(inputs)
	return en_tut_sc_approvals(inputs)
});